import React, { useEffect, useState } from "react";
import ContactsBox from "./ContactsBox";
import api from "@common/utils/api";
const SupportRow = () => {
    const [leftComponent, setLeftComponent] = useState(null);
    const [rightComponent, setRightComponent] = useState(null);
    const [staticLeft, setStaticLeft] = useState(false);
    const [staticRight, setStaticRight] = useState(false);
    const [overwriteLeft, setOverwriteLeft] = useState(false);
    const [overwriteRight, setOverwriteRight] = useState(false);
    const buildComponent = (component) => {
        var _a, _b, _c, _d, _e, _f, _g;
        let result = null;
        if (component) {
            result = {
                title: (_b = (_a = component[0]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.title,
                description: (_d = (_c = component[0]) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.description,
                links: ((_f = (_e = component[0]) === null || _e === void 0 ? void 0 : _e.regions[0]) === null || _f === void 0 ? void 0 : _f.components) ? (_g = component[0].regions[0]) === null || _g === void 0 ? void 0 : _g.components : []
            };
        }
        return result;
    };
    useEffect(() => {
        api.getPageJson('my_account_support', true).then((data) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
            if ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.regions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.components) === null || _c === void 0 ? void 0 : _c[0].data.loadFromBM) {
                setStaticLeft(true);
                setOverwriteLeft((_f = (_e = (_d = data === null || data === void 0 ? void 0 : data.regions) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.components) === null || _f === void 0 ? void 0 : _f[0].data.overwriteLink);
            }
            let leftComponent = (_h = (_g = data === null || data === void 0 ? void 0 : data.regions) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.components;
            leftComponent = buildComponent(leftComponent);
            setLeftComponent(leftComponent);
            if ((_l = (_k = (_j = data === null || data === void 0 ? void 0 : data.regions) === null || _j === void 0 ? void 0 : _j[1]) === null || _k === void 0 ? void 0 : _k.components) === null || _l === void 0 ? void 0 : _l[0].data.loadFromBM) {
                setStaticRight(true);
                setOverwriteRight((_p = (_o = (_m = data === null || data === void 0 ? void 0 : data.regions) === null || _m === void 0 ? void 0 : _m[1]) === null || _o === void 0 ? void 0 : _o.components) === null || _p === void 0 ? void 0 : _p[0].data.overwriteLink);
            }
            let rightComponent = (_r = (_q = data === null || data === void 0 ? void 0 : data.regions) === null || _q === void 0 ? void 0 : _q[1]) === null || _r === void 0 ? void 0 : _r.components;
            rightComponent = buildComponent(rightComponent);
            setRightComponent(rightComponent);
        });
    }, []);
    return React.createElement(React.Fragment, null, (leftComponent || rightComponent || staticLeft || staticRight) &&
        React.createElement("div", { className: "support-section-footer-row" },
            staticLeft
                ?
                    React.createElement(ContactsBox, { showContacts: true, hideLinks: overwriteLeft, component: leftComponent })
                :
                    React.createElement(ContactsBox, { component: leftComponent }),
            staticRight
                ?
                    React.createElement(ContactsBox, { showContacts: true, hideLinks: overwriteRight, component: rightComponent })
                :
                    React.createElement(ContactsBox, { component: rightComponent })));
};
export default SupportRow;
